import React from "react";
import { MapPin, Clock, Navigation } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { BUSINESS } from "@/data/business";

export const ServiceArea = () => {
  const { lang, tr } = useLang();
  const { business } = useContent();
  const kn = lang === "kn";
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(business.address)}&output=embed`;

  return (
    <section id="area" className="py-16 lg:py-24 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid gap-10 lg:grid-cols-2 items-center">
          <div>
            <p className={`text-xs font-bold uppercase tracking-widest text-amber-700 ${kn ? "font-kn" : ""}`}>{tr("area_kicker")}</p>
            <h2 className={`mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 ${kn ? "font-kn" : "font-heading"}`}>{tr("area_title")}</h2>
            <p className={`mt-3 text-base text-slate-600 ${kn ? "font-kn" : ""}`}>{tr("area_sub")}</p>

            <div className="mt-6 flex flex-wrap gap-2">
              {BUSINESS.areas.map((a) => (
                <span key={a} data-testid={`area-chip-${a}`} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm font-medium text-slate-700">
                  <MapPin size={13} className="text-primary" /> {a}
                </span>
              ))}
            </div>

            <div className="mt-7 space-y-3 rounded-2xl border border-slate-200 bg-slate-50 p-5">
              <div className="flex items-start gap-3">
                <Navigation size={18} className="mt-0.5 shrink-0 text-primary" />
                <p className={`text-sm font-medium text-slate-700 ${kn ? "font-kn" : ""}`}>{business.address}</p>
              </div>
              <div className="flex items-start gap-3">
                <Clock size={18} className="mt-0.5 shrink-0 text-primary" />
                <p className={`text-sm font-medium text-slate-700 ${kn ? "font-kn" : ""}`}>{kn ? BUSINESS.hours_kn : business.hours_en}</p>
              </div>
            </div>
          </div>

          <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-lg">
            <iframe
              title="Creative Prints location"
              src={mapSrc}
              className="h-[360px] w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
